import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const SwagerGuard = ({ children, ...rest }) => {
  const token = localStorage.getItem("token:data");

  const { profile } = useSelector((state) => state.users);

  let isSwagerAdminGuard = profile
    ? (profile.role && 
        ((profile.role.map((role) => role.name).includes("admin")) || (profile.role.map((role) => role.name).includes("swager_admin")))
      )
    : false;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        token && isSwagerAdminGuard ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: {
                from: location,
              },
            }}
          />
        )
      }
    />
  );
};

export default SwagerGuard;
